<template>
  <div class="btn-group action-button-group" role="group">
    <router-link :to="`/shops/${id}`" class="btn btn-sm btn-success action-button-group--link">
      show
    </router-link>
  </div>
</template>

<script>
export default {
    name: 'Actions',
    props: {
        id:{
            type:String
        }
    }
};
</script>
